import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

export default function RangeSlider({handlePriceRange, defaultRange}) {

    const [value, setValue] = React.useState([0,20]);

    useEffect(() => {
      setValue([defaultRange.min, defaultRange.max])
    }, [defaultRange])
    

    const handleChange = (event, newValue) => {
      setValue(newValue);
      handlePriceRange(newValue[0], newValue[1])
    };

    let slider = '';

    if (defaultRange.min !== undefined) {
         slider = <Slider
         value={value}
         onChange={handleChange}
         color="secondary"
         min={Math.floor(defaultRange.min/100)*100}
         max={Math.ceil(defaultRange.max/100)*100}
       /> 
    }

    return (
      <Box sx={{ width: "90%" }}>
        {slider}
      </Box>
    );
}